<template>
    <div class="new-title">
        <router-link :to="{path:'/postDetails'}">
            <p class="post-details-title">
                {{data.title}}
            </p>
            <div v-if="data.imgList&&data.imgList.length>0" class="news-img-list">
                <div class="news-img-item" v-for="img in data.imgList">
                    <img src="../assets/img/logo.png">
                </div>
            </div>
            <p class="post-details-desc van-hairline--bottom">
                <span class="author">作者:{{data.author}}</span>
                <span class="time">{{data.time}}</span>
                <span class="comment"><img src="../assets/img/pinglun.png" alt="">{{data.commentNum||0}}</span>
                <span class="view-num"><img src="../assets/img/yanjing.png" alt="">{{data.viewtNum||0}}</span>
            </p>
        </router-link>
    </div>
</template>
<script>

    export default {
        data() {
            return {}
        },
        props: {
            data: {
                type: Object,
                default: () => { }
            }
        }
    }
</script>
<style>
    .new-title {
        overflow: hidden;
        background-color: #fff;
        margin-bottom: 20px;
    }

    .news-img-list {
        display: flex;
        width: 684px;
        margin: 0 auto;
        flex-wrap: wrap;
    }

    .news-img-item {
        width: 136px;
        height: 136px;
        margin-left: 8px;
        background-color: #f5f5f5;
        text-align: center;
        line-height: 136px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 16px;
    }

    .news-img-item img {
        max-width: 100%;
    }

    .post-details-title {
        font-size: 34px;
        font-family: pingFangSC-Regular;
        font-weight: 400;
        color: #333333;
        line-height: 48px;
        margin: 36px auto 16px;
        width: 684px;
        text-align: left;
    }

    .post-details-desc {
        font-size: 24px;
        width: 684px;
        font-family: pingFangSC-Regular;
        font-weight: 400;
        color: rgba(166, 166, 166, 1);
        line-height: 33px;
        vertical-align: middle;
        padding-bottom: 24px;
        margin: 0 auto;
        overflow: hidden;
    }

    .post-details-desc .author {
        float: left;
        white-space: nowrap;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 26px;
    }

    .post-details-desc .time {
        float: left;
    }

    .post-details-desc .view-num,
    .post-details-desc .comment {
        float: right;
        vertical-align: middle;
    }

    .post-details-desc .comment {
        margin-left: 42px;
    }

    .view-num img {
        width: 23px;
        display: inline-block;
        margin-right: 10px;
    }

    .comment img {
        width: 18px;
        display: inline-block;
        margin-right: 10px;
    }
</style>